import { CreateFacultyType } from "../../../types/Faculty";
import { post } from "../../../utils/axios-config";
import { FACULTIES } from "../../../utils/constants";

export const createFaculty = async (data: CreateFacultyType) => await post<CreateFacultyType, string>(FACULTIES, data);